export default __webpack_public_path__ + "static/media/watchtower.9a5a7066.svg";